import React from 'react';
import './AppPageHeader.css';

type AppPageHeaderProps = React.HTMLAttributes<HTMLElement> & {
  kicker?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  description?: React.ReactNode;
  metrics?: React.ReactNode;
  actions?: React.ReactNode;
  secondaryActions?: React.ReactNode;
  className?: string;
  titleId?: string;
  variant?: 'default' | 'banner';
};

export default function AppPageHeader({
  kicker,
  title,
  subtitle,
  description,
  metrics,
  actions,
  secondaryActions,
  className,
  titleId,
  variant = 'default',
  ...sectionProps
}: AppPageHeaderProps): JSX.Element {
  const classes = [
    'app-page-header',
    variant === 'banner' ? 'app-page-header--banner' : '',
    className,
  ].filter(Boolean).join(' ');
  const resolvedDescription = subtitle ?? description;

  return (
    <section {...sectionProps} className={classes} aria-labelledby={titleId}>
      <div className="app-page-header-copy">
        {kicker && variant !== 'banner' && <div className="app-page-header-kicker">{kicker}</div>}
        <h1 className="app-page-header-title" id={titleId}>{title}</h1>
        {resolvedDescription && <p className="app-page-header-description">{resolvedDescription}</p>}
      </div>
      {(metrics || actions || secondaryActions) && (
        <div className="app-page-header-side">
          {metrics && <div className="app-page-header-metrics">{metrics}</div>}
          {actions && <div className="app-page-header-actions">{actions}</div>}
          {secondaryActions && <div className="app-page-header-secondary-actions">{secondaryActions}</div>}
        </div>
      )}
    </section>
  );
}
